export default "__VITE_ASSET__kkg4X_St__"